import styles from "./messages.module.scss"

interface Props {
  message: string
  severity: "warning" | "error"
  recoverable: boolean
  onResetChat?: () => void
}

const SystemNotice = ({ message, severity, recoverable, onResetChat }: Props) => {
  const variant = severity === "warning" ? "warning" : recoverable ? "recoverable" : "terminal"
  const showReset = severity === "error" && !recoverable && Boolean(onResetChat)

  return (
    <div
      className={styles["row"]}
      data-testid="system-notice"
      data-severity={severity}
      data-recoverable={String(recoverable)}
    >
      <div className={`${styles["notice"]} ${styles[`notice--${variant}`]}`} role="alert">
        <span className={styles["notice__text"]}>{message}</span>
        {showReset ? (
          <button type="button" className={styles["notice__action"]} onClick={onResetChat}>
            Start new chat
          </button>
        ) : null}
      </div>
    </div>
  )
}

export default SystemNotice
